import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';

import { PeriodicItem } from '../models/periodicitem.model';
import { ServiceInstanceTotals } from '../models/serviceinstance.model';
import { BaseService } from './base.service';

export class PeriodicEntityService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	saveAllPeriodicItemForService(idservice: number, items: PeriodicItem[]): Promise<PeriodicItem[]> {
		return this.mapResponse<PeriodicItem[]>(this.http.post(`/ws/periodicitem/service/${idservice}/list`, classToPlain(items)), PeriodicItem);
	}

	periodicServiceTotals(id: number): Promise<ServiceInstanceTotals> {
		return this.mapResponse<ServiceInstanceTotals>(this.http.get(`/ws/periodicservice/${id}/amount`), ServiceInstanceTotals);
	}
}